<template>
  <header-layout />
  <auth-view
    title="Sign up"
    mode="register"
  />
  <div class="_bottom">
    Already have an account? <router-link
      class="-underline"
      :to="{ name: $routes.home }"
    >
      Log in here
    </router-link>
  </div>
</template>

<script>

import AuthView from 'shared/components/AuthView.vue';
import HeaderLayout from 'shared/components/HeaderLayout.vue';
import { USER_SERVICE } from 'shared/constants';
import { inject } from 'vue';

export default {
  name: 'RegisterView',
  setup() {
    const userService = inject(USER_SERVICE);
    return {
      currentUser: userService.currentUser,
      userLoading: userService.loading,
    };
  },
  components: { HeaderLayout, AuthView },
  created() {
    if (this.currentUser !== null) {
      this.$router.push({ name: this.$routes.home });
    }
  },
};
</script>

<style
    scoped
    lang="scss"
    type="text/scss"
>
  ._bottom {
    text-align: center;
    color: map_get($grey, 'lighten-1');
  }
</style>
